export default "__VITE_ASSET__nCkC4dPR__"